<app-background-image data-state="shipping"></app-background-image>
<app-topbar></app-topbar>

<app-sidebar>
    <div class="sidebar-header">
        <h5>New Project</h5>
    </div>
    <div style="height: 30px"></div>
    <ul class="nav flex-column navbar-nav">
        <li class="d-grid gap-2">
            <button class="btn btn-outline-primary btn-block"
                    type="button"
                    (click)="manageComponents()">
                Components
            </button>
        </li>
        <li class="d-grid gap-2">
            <button class="btn btn-outline-primary btn-block"
                    type="button"
                    (click)="manageEventTypes()">
                Event Types
            </button>
        </li>
        <li class="d-grid gap-2">
            <button class="btn btn-outline-primary btn-block required {{isFilled(project.mailingListId)}}"
                    type="button"
                    (click)="manageMailingList()">
                Mail Recipients
            </button>
        </li>
    </ul>

    <div style="height: 30px"></div>
    <form (ngSubmit)="create()">
        <ul class="nav flex-column navbar-nav">
            <li class="d-grid gap-2">
                <button class="btn btn-primary btn-block"
                        type="submit"
                        [disabled]="!inputValid">
                    Create Project
                </button>
            </li>
        </ul>
    </form>
    <ul class="nav flex-column navbar-nav">
        <li class="d-grid gap-2">
            <button class="btn btn-primary btn-block"
                    type="button"
                    (click)="manageTemplateProjects()">
                Load Template
            </button>
        </li>
        <li class="d-grid gap-2">
            <button class="btn btn-primary btn-block"
                    type="submit"
                    (click)="createTemplate()"
                    [disabled]="!templateInputValid">
                Save as Template
            </button>
        </li>
    </ul>
</app-sidebar>

<div class="main-content">
    <app-edit-project-inner [project]="project"></app-edit-project-inner>
</div>
